import request from './http.js'
//   请求网页授权接口
export function oauthUrl(params) {
  return request({
    url: '/oauthUrl',
    method: 'post',
    data: params
  })
};
// 获取js-sdk配置接口
export function getJsSdkConfig(params) {
  return request({
    url: '/getJsSdkConfig',
    method: 'post',
    data: params
  })
};
// 登录
export function login(params) {
  return request({
    url: '/parents/Login',
    method: 'post',
    data: params
  })
};
// 助手静默恢复
export function restoreAssistantSession(params) {
  return request({
    url: '/assistant/restoreSession',
    method: 'post',
    data: params
  })
};
// 获取验证码
export function sendSMS(params) {
  return request({
    url: '/api/h5/sms/send',
    baseURL: '',
    method: 'post',
    data: params
  })
};
// 重置密码
export function SetPassword(params) {
  return request({
    url: '/parents/SetPassword',
    method: 'post',
    data: params
  })
};
// 首页列表
export function studentReportList(params) {
  return request({
    url: '/parents/getStudentReportList',
    method: 'post',
    data: params
  })
};
// 日，周，月报告详情
export function studentReportInfo(params) {
  return request({
    url: '/parents/getStudentReportInfo',
    method: 'post',
    data: params
  })
};
// 日历页请求报告
export function getStudentReportListByDate(params) {
  return request({
    url: '/parents/getStudentReportListByDate',
    method: 'post',
    data: params
  })
};
// 分享页用户信息
export function shareStudentReportInfo(params) {
  return request({
    url: '/share/parents/shareStudentReportInfo',
    method: 'post',
    data: params
  })
};
//埋点
export function parentActionLog(params) {
  return request({
    url: '/parents/parentActionLog',
    method: 'post',
    data: params
  })
};
// 家长退出登录
export function parentLogout(params) {
  return request({
    url: '/parents/Logout',
    method: 'post',
    data: params
  })
};
//查看该学生某一个作业报告
export function homeworkReportInfo(params) {
  return request({
    url: '/parents/getStudentHomeworkReportInfo',
    method: 'post',
    data: params
  })
};



// WEBPACK FOOTER //
// ./src/apis/baseUrls.js